var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconaProfilo50(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icona-profilo-50") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.101800195 49.4972252 0.101800195 49.4972252 49.5988919 0 49.5988919"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona-profilo-50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profilo_riposo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4972252,24.8503461 C49.4972252,38.5185291 38.4168623,49.5988919 24.7486793,49.5988919 C11.0802739,49.5988919 -8.8966742e-05,38.5185291 -8.8966742e-05,24.8503461 C-8.8966742e-05,11.1821631 11.0802739,0.101800195 24.7486793,0.101800195 C38.4168623,0.101800195 49.4972252,11.1821631 49.4972252,24.8503461",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25,45.8333333 C18.0556263,45.8333333 11.916869,42.164941 8.33333333,36.6049837 C8.41680957,30.9016773 19.4444444,27.7777778 25,27.7777778 C30.5278245,27.7777778 41.5831904,30.9016773 41.6666667,36.6049837 C38.083131,42.164941 31.9443737,45.8333333 25,45.8333333",
    id: "Fill-4",
    fill: "#4E565A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,5.55555556 C29.6112637,5.55555556 33.3333333,9.27784465 33.3333333,13.8887476 C33.3333333,18.4999331 29.6112637,22.2222222 25,22.2222222 C20.3887363,22.2222222 16.6666667,18.4999331 16.6666667,13.8887476 C16.6666667,9.27784465 20.3887363,5.55555556 25,5.55555556",
    id: "Fill-6",
    fill: "#4E565A"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaProfilo50);
export default __webpack_public_path__ + "static/media/icona-profilo-50.627893e91a7e3f952acfeb5333e17729.svg";
export { ForwardRef as ReactComponent };